import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dmitry.petrov/Workspace/dxfeed-js-api/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "nodejs-usage"
    }}>{`NodeJS usage`}</h1>
    <p>{`Install `}<inlineCode parentName="p">{`cometd-nodejs-client`}</inlineCode>{` package`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install cometd-nodejs-client
`}</code></pre>
    <p>{`and use it in your code`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`require('cometd-nodejs-client').adapt()
// or
import * as CometdNodejsClient from 'cometd-nodejs-client'
CometdNodejsClient.adapt()
`}</code></pre>
    <h1 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h1>
    <p>{`We have several classes in implementation:`}</p>
    <ul>
      <li parentName="ul">{`Feed `}<strong parentName="li"><em parentName="strong">{`(public)`}</em></strong></li>
      <li parentName="ul">{`Endpoint `}<strong parentName="li"><em parentName="strong">{`(private)`}</em></strong></li>
      <li parentName="ul">{`Subscriptions `}<strong parentName="li"><em parentName="strong">{`(private)`}</em></strong></li>
    </ul>
    <p>{`The `}<em parentName="p">{`Feed`}</em>{` is entry point for configuration and creating subscriptions.
`}<em parentName="p">{`Feed`}</em>{` manages private classes for connecting and subscribing.
The `}<em parentName="p">{`Endpoint`}</em>{` is responsible for managing the web socket connection.
`}<em parentName="p">{`Subscriptions`}</em>{` for managing open subscriptions.`}</p>
    <h2 {...{
      "id": "import-package"
    }}>{`Import package`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import Feed from '@dxfeed/api'
`}</code></pre>
    <h2 {...{
      "id": "configure--create-connection"
    }}>{`Configure & Create connection`}</h2>
    <p>{`Create instance of Feed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const feed = new Feed()
`}</code></pre>
    <p>{`Provide auth token if needed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`feed.setAuthToken('authToken')
`}</code></pre>
    <p>{`Set web socket address and open connection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`feed.connect('wss://demo.dxfeed.com/webservice/cometd')
`}</code></pre>
    <h2 {...{
      "id": "configure--create-subscription"
    }}>{`Configure & Create subscription`}</h2>
    <p>{`You should specify event types and symbol names.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`feed.subscribe<{ value: number }>(
  [EventType.Summary, EventType.Trade] /* event types */,
  ['AEX.IND:TEI'] /* symbols */,
  handleEvent
)
`}</code></pre>
    <p>{`For timed subscription you should also provide time to start subscription from.`}</p>
    <p>{`For Candle event type along with base symbol, you should specify an aggregation period. You can also set price type. More details: `}<a parentName="p" {...{
        "href": "https://kb.dxfeed.com/display/DS/REST+API#RESTAPI-Candlesymbols"
      }}>{`https://kb.dxfeed.com/display/DS/REST+API#RESTAPI-Candlesymbols`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`feed.subscribeTimeSeries<{ value: number }>(
  [EventType.Summary, EventType.Trade] /* event types */,
  ['AEX.IND:TEI'] /* symbols */,
  0 /* fromTime */,
  handleEvent
)
`}</code></pre>
    <p>{`Last argument its event handler for process incoming events.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const handleEvent = (event) => {
  /* process event */
}
`}</code></pre>
    <h2 {...{
      "id": "close-subscription"
    }}>{`Close subscription`}</h2>
    <p>{`All subscribe methods return unsubscribe handler, you need to call this method for unsubscribe.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const unsubscribe = feed.subscribe(eventTypes, symbols, handleEvent)

onExit(() => unsubscribe())
`}</code></pre>
    <h2 {...{
      "id": "aggregated-api"
    }}>{`Aggregated API`}</h2>
    <h3 {...{
      "id": "get-timeseries"
    }}>{`Get TimeSeries`}</h3>
    <p>{`If you want to get TimeSeries events for a given time period, refer to example below.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`// inside async function
const events = await feed.getTimeSeries(
  'AAPL{=15m}',
  EventType.Candle,
  fromDate.getTime(),
  toDate.getTime()
)
`}</code></pre>
    <h3 {...{
      "id": "subscribe-timeseries-snapshot"
    }}>{`Subscribe TimeSeries snapshot`}</h3>
    <p>{`If you want to subscribe to TimeSeries events, refer to example below.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const unsubscribe = feed.subscribeTimeSeriesSnapshot('AAPL{=15m}', EventType.Candle, (candles) => {
  // process candles
  chart.setCandles(candles)
})
`}</code></pre>
    <h2 {...{
      "id": "close-connection"
    }}>{`Close connection`}</h2>
    <p>{`If you need to close the web socket connection`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`feed.disconnect()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      